import { ComplexList, DefaultEdit, ObserveList } from 'complex-data'
import vehicleApi from '@/pages/index/api/vehicle'
import { buildDictionaryBySelect } from '@/config/dictionary'
import { vehicleDisposeType } from '@/pages/index/select/vehicle'
import { ApprovalStatus } from '@/pages/index/select'
import LayoutParse from '@/config/utils/layout'
import { notice } from 'complex-plugin'
import { listWidth } from '@/config/dictionary/config'
import { uploadFile } from '@/pages/index/utils/file'
import { RegExpRule } from '@/config/utils'
import { dict } from '@/pages/index/select/dict'
import config from '@/config'
import old from '@/pages/index/data/old'
import { getNum } from 'complex-utils'

export class DisposeList extends ComplexList {
  buildItem(postData: Record<string, unknown>, payload: { id: string }) {
    return new Promise((resolve, reject) => {
      postData.overdueRecordId = payload.id
      vehicleApi.vehicleDisposeBuild.require(postData).then(() => {
        notice.showMsg('车辆处置申请成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  changeItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>, flowKey: string) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      postData.curTaskDefKey = flowKey
      vehicleApi.vehicleDisposeChange.require(postData).then(() => {
        notice.showMsg('车辆处置申请审批成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  rejectItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      vehicleApi.vehicleDisposeReject.require(postData).then(() => {
        notice.showMsg('车辆处置申请驳回完成！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  settleItem(targetData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      if (!targetData.initEarlySettlementTaskno) {
        vehicleApi.vehicleDisposeSettle.require({
          id: targetData.id as string
        }).then((res) => {
          targetData.initEarlySettlementFlowunit = res.data.data.initEarlySettlementFlowunit
          targetData.initEarlySettlementTaskno = res.data.data.initEarlySettlementTaskno
          old.toSettlement(targetData.initEarlySettlementTaskno as string)
          resolve({ status: 'success' })
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
          reject(err)
        })
      } else {
        old.toSettlement(targetData.initEarlySettlementTaskno as string)
        resolve({ status: 'success' })
      }
    })
  }
}

const layoutParse = new LayoutParse(2, 8, 16)

const searchLayoutParse = new LayoutParse(4, 8, 16)

type editConfigType = {
  reduction?: string // 减免判断
  reductionName?: string
  count?: {
    type?: boolean
    handle?: boolean
    trigger?: boolean
    change?: (target: ObserveList, value: number, type: string) => void
  }
}

const editConfig = {
  data: {
    principalAmount: {
      // 本金
      reduction: 'reductionPrincipalAmount',
      reductionName: '亏损',
      count: {
        type: true,
        trigger: true
      },
    },
    reductionPrincipalAmount: {
      // 亏损后本金
      count: {
        handle: true,
        trigger: true
      },
    },
    interestAmount: {
      // 利息
      reduction: 'reductionInterestAmount',
      count: {
        type: true,
        trigger: true
      }
    },
    reductionInterestAmount: {
      // 减免后利息
      count: {
        handle: true,
        trigger: true
      },
    },
    liquidatedAmount: {
      // 违约金
      reduction: 'reductionLiquidatedAmount'
    },
    reductionLiquidatedAmount: {
      // 减免后违约金
      count: {
        handle: true,
        trigger: true
      },
    },
    hirePurchaseAmount: {
      // 留购价款
      reduction: 'reductionHirePurchaseAmount',
      amountInit: true
    },
    reductionHirePurchaseAmount: {
      // 减免后留购价款
      count: {
        handle: true,
        trigger: true
      },
    },
    punishAmount: {
      // 罚息
      reduction: 'reductionPunishAmount',
    },
    reductionPunishAmount: {
      // 减免后罚息
      count: {
        handle: true,
        trigger: true
      },
    },
    collectionAmount: {
      // 收车费用
      reduction: 'reductionCollectionAmount',
      count: {
        type: true,
        trigger: true
      }
    },
    reductionCollectionAmount: {
      // 减免后收车费用
      count: {
        handle: true,
        trigger: true
      },
    },
    parkAmount: {
      // 停车费用
      reduction: 'reductionParkAmount',
      count: {
        type: true,
        trigger: true,
        change(target, value) {
          changeAmountReductionRuleByType(target, editConfig.data.parkAmount, value)
        }
      },
    },
    reductionParkAmount: {
      // 减免后停车费用
      count: {
        handle: true,
        trigger: true
      },
    },
    handleAmount: {
      // 处置金额
      count: {
        change(target) {
          countLossAmount(target.$data!)
        }
      },
    },
  } as Record<string, editConfigType>
}

// 计算总金额
function countAmount(target: ObserveList, currentProp: true | string) {
  let count = false
  if (currentProp === true) {
    count = true
  } else {
    const currentConfigItem = editConfig.data[currentProp]
    if (currentConfigItem && currentConfigItem.count) {
      if (currentConfigItem.count.change) {
        currentConfigItem.count.change(target, Number(target.$data![currentProp] || 0), target.$data!.handleType)
      }
      if (currentConfigItem.count.trigger) {
        count = true
      }
    }
  }
  if (count) {
    let totalAmount = 0
    let handleAmount = 0
    for (const prop in editConfig.data) {
      const editConfigItem = editConfig.data[prop]
      if (editConfigItem.count) {
        if (editConfigItem.count.type) {
          const targetAmount = Number(target.$data![prop] || 0) * 100
          totalAmount += targetAmount
        }
        if (editConfigItem.count.handle) {
          const targetAmount = Number(target.$data![prop] || 0) * 100
          handleAmount += targetAmount
        }
      }
    }
    // 总应收金额
    target.$data!.receivableAmount = getNum(totalAmount / 100)
    target.$data!.handleAmount = getNum(handleAmount / 100)
    countLossAmount(target.$data!)
  }
}

// 计算亏损金额
function countLossAmount(form: Record<string, any>) {
  let handleLossAmount = (form.receivableAmount || 0) - (form.handleAmount || 0)
  if (handleLossAmount < 0) {
    handleLossAmount = 0
  }
  form.handleLossAmount = getNum(handleLossAmount)
}

// 根据初始值限制金额
function initAmountReductionRuleByValue(target: ObserveList) {
  for (const prop in editConfig.data) {
    const editConfigItem = editConfig.data[prop]
    changeAmountReductionRuleByType(target, editConfigItem, target.$data![prop])
  }
}
// 修改对应的减免限制
function changeAmountReductionRuleByType(target: ObserveList, editConfigItem: editConfigType, value?: number | string) {
  if (editConfigItem.reduction) {
    value = Number(value || 0)
    const reductionEdit = target.getItem(editConfigItem.reduction) as DefaultEdit<'inputNumber'>
    // reductionEdit.$option.max = value
    const rule = reductionEdit.$rules.getData('default')
    if (rule[1]) {
      rule[1].max = value
    } else {
      rule.push({
        type: 'number',
        message: (editConfigItem.reductionName || '减免') + '后费用不能超过原费用',
        min: 0,
        max: value
      })
    }
  }
}

const disposeList = new DisposeList({
  name: '车辆处置申请',
  prop: 'disposeList',
  module: {
    pagination: true,
    search: {
      module: {
        dictionary: {
          layout: {
            default: searchLayoutParse.getData(4)
          },
          list: [
            buildDictionaryBySelect(dict.business_lines_green, {
              prop: 'itemname',
              name: '业务线',
              originProp: 'itemname',
              originFrom: 'local',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }, {
              onlyLabel: true
            }),
            {
              prop: 'contractNumber',
              name: '合同号',
              originProp: 'contractNumber',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'customerName',
              name: '承租人',
              originProp: 'customerName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'createdName',
              name: '创建人',
              originProp: 'createdName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'vinNo',
              name: '车架号',
              originProp: 'vinNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'engineNo',
              name: '发动机编号',
              originProp: 'engineNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'beginCreatedTime',
              name: '创建时间',
              originProp: 'beginCreatedTime',
              originFrom: 'local',
              layout: {
                default: searchLayoutParse.getData(2)
              },
              post(value, { targetData }) {
                if (value) {
                  targetData.endCreatedTime = (value as string[])[1]
                  return (value as string[])[0]
                }
              },
              mod: {
                search: {
                  $type: 'edit',
                  type: 'dateRange',
                  option: {
                    time: {}
                  }
                }
              }
            },
          ]
        }
      },
      menu: {
        list: []
      },
    },
    dictionary: {
      layout: {
        default: layoutParse.getData(2)
      },
      option: {},
      propData: {
        id: 'id'
      },
      list: [
        {
          prop: 'menu',
          name: '操作',
          originProp: 'menu',
          originFrom: 'local',
          mod: {
            list: {
              width: listWidth.getWidth(7),
              local: {
                fixed: 'left'
              },
            }
          }
        },
        {
          prop: 'id',
          name: 'ID',
          originProp: 'id',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'initEarlySettlementFlowunit',
          name: '初始化老系统提前结清流程id',
          originProp: 'initEarlySettlementFlowunit',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'initEarlySettlementTaskno',
          name: '初始化老系统提前结清任务号',
          originProp: 'initEarlySettlementTaskno',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'code',
          name: '申请编号',
          originProp: 'code',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(0, 11, 2)
            }
          }
        },
        {
          prop: 'overdueRecordId',
          name: '逾期记录ID',
          originProp: 'overdueRecordId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'applyUserId',
          name: '申请人ID',
          originProp: 'applyUserId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'contractNumber',
          name: '合同号',
          originProp: 'contractNumber',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.contractNumber
            }
          }
        },
        {
          prop: 'itemname',
          name: '业务线',
          originProp: 'itemname',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.businessLine
            }
          }
        },
        {
          prop: 'customerName',
          name: '承租人',
          originProp: 'customerName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'brandname',
          name: '品牌',
          originProp: 'brandname',
          originFrom: 'list',
          mod: {
            list: {}
          }
        },
        {
          prop: 'vinNo',
          name: '车架号',
          originProp: 'vinNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vin
            }
          }
        },
        {
          prop: 'engineNo',
          name: '发动机编号',
          originProp: 'engineNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vehicleEngineNo
            }
          }
        },
        buildDictionaryBySelect(ApprovalStatus, {
          prop: 'applyStatus',
          name: '审批状态',
          originProp: 'applyStatus',
          originFrom: 'list',
          mod: {
            list: {}
          }
        }),
        {
          prop: 'settleDataSyncDate',
          name: '价格时间',
          originProp: 'settleDataSyncDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init' && prop === this.prop) {
                  if (target.$order.includes('settleDataSyncDate')) {
                    target.hidden('settleDataSyncDate')
                  }
                }
              },
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            }
          }
        },
        // {
        //   prop: 'secondHandCarQuotation',
        //   name: '二手车报价',
        //   originProp: 'secondHandCarQuotation',
        //   originFrom: 'list',
        //   mod: {
        //     edit: {
        //       type: 'inputNumber',
        //       disabled: {
        //         default: false,
        //         ufo_cs_cz_20: true,
        //         ufo_cs_cz_30: true,
        //         ufo_cs_cz_40: true,
        //         ufo_cs_cz_50: true,
        //       },
        //       required: true,
        //       option: {
        //         min: 0,
        //         precision: 2
        //       }
        //     },
        //     ufo_cs_cz_10: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_20: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_30: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_40: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_50: {
        //       $target: 'edit'
        //     },
        //   }
        // },
        // {
        //   prop: 'platformQuotation',
        //   name: '平台报价',
        //   originProp: 'platformQuotation',
        //   originFrom: 'list',
        //   mod: {
        //     edit: {
        //       type: 'inputNumber',
        //       required: true,
        //       disabled: {
        //         default: false,
        //         ufo_cs_cz_20: true,
        //         ufo_cs_cz_30: true,
        //         ufo_cs_cz_40: true,
        //         ufo_cs_cz_50: true,
        //       },
        //       option: {
        //         min: 0,
        //         precision: 2
        //       }
        //     },
        //     ufo_cs_cz_10: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_20: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_30: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_40: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_50: {
        //       $target: 'edit'
        //     },
        //   }
        // },
        // {
        //   prop: 'dealerQuotation',
        //   name: '经销商报价',
        //   originProp: 'dealerQuotation',
        //   originFrom: 'list',
        //   layout: {
        //     default: layoutParse.getData(1)
        //   },
        //   mod: {
        //     edit: {
        //       type: 'inputNumber',
        //       required: true,
        //       disabled: {
        //         default: false,
        //         ufo_cs_cz_20: true,
        //         ufo_cs_cz_30: true,
        //         ufo_cs_cz_40: true,
        //         ufo_cs_cz_50: true,
        //       },
        //       option: {
        //         min: 0,
        //         precision: 2
        //       }
        //     },
        //     ufo_cs_cz_10: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_20: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_30: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_40: {
        //       $target: 'edit'
        //     },
        //     ufo_cs_cz_50: {
        //       $target: 'edit'
        //     },
        //   }
        // },
        {
          prop: 'principalAmount',
          name: '本金',
          originProp: 'principalAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionPrincipalAmount',
          name: '亏损后本金',
          originProp: 'reductionPrincipalAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'interestAmount',
          name: '利息',
          originProp: 'interestAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionInterestAmount',
          name: '减免后利息',
          originProp: 'reductionInterestAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'liquidatedAmount',
          name: '违约金',
          originProp: 'liquidatedAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionLiquidatedAmount',
          name: '减免后违约金',
          originProp: 'reductionLiquidatedAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'hirePurchaseAmount',
          name: '留购价款',
          originProp: 'hirePurchaseAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionHirePurchaseAmount',
          name: '减免后留购价款',
          originProp: 'reductionHirePurchaseAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'punishAmount',
          name: '罚息',
          originProp: 'punishAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionPunishAmount',
          name: '减免后罚息',
          originProp: 'reductionPunishAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'collectionAmount',
          name: '收车费用',
          originProp: 'collectionAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionCollectionAmount',
          name: '减免后收车费用',
          originProp: 'reductionCollectionAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'parkAmount',
          name: '停车费用',
          originProp: 'parkAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              disabled: {
                default: false,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionParkAmount',
          name: '减免后停车费用',
          originProp: 'reductionParkAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'receivableAmount',
          name: '总应收金额',
          originProp: 'receivableAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        buildDictionaryBySelect(vehicleDisposeType, {
          prop: 'handleType',
          name: '处置类型',
          originProp: 'handleType',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            list: {},
            edit: {
              required: true,
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from !== 'init') {
                  if (prop === this.prop) {
                    countAmount(target, true)
                  } else {
                    countAmount(target, prop as string)
                  }
                } else {
                  if (prop === this.prop) {
                    initAmountReductionRuleByValue(target)
                  }
                }
              },
            },
            show: {
              $type: 'edit',
              required: true,
              disabled: true,
              type: 'select',
              option: {
                list: vehicleDisposeType.getList()
              },
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init') {
                  if (prop === this.prop) {
                    initAmountReductionRuleByValue(target)
                  }
                } else {
                  countAmount(target, prop as string)
                }
              },
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'show'
            },
            ufo_cs_cz_30: {
              $target: 'show'
            },
            ufo_cs_cz_40: {
              $target: 'show'
            },
            ufo_cs_cz_50: {
              $target: 'show'
            },
          }
        }),
        {
          prop: 'handleAmount',
          name: '处置金额',
          originProp: 'handleAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              disabled: {
                default: true,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'handleLossAmount',
          name: '亏损金额',
          originProp: 'handleLossAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'buyCarName',
          name: '购买人姓名',
          originProp: 'buyCarName',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              disabled: {
                default: false,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true,
              },
              required: false
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'buyCarPhone',
          name: '购买人电话',
          originProp: 'buyCarPhone',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              disabled: {
                default: false,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true,
              },
              required: false,
              option: {
                maxLength: 20
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.mobilePhone.test(val) || RegExpRule.linePhone.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的联系方式'
                }
              ]
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'buyCarCard',
          name: '购买人身份证',
          originProp: 'buyCarCard',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              disabled: {
                default: false,
                ufo_cs_cz_20: true,
                ufo_cs_cz_30: true,
                ufo_cs_cz_40: true,
                ufo_cs_cz_50: true,
              },
              required: false,
              option: {
                maxLength: 18
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.identityCard.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的身份证号'
                }
              ]
            },
            ufo_cs_cz_10: {
              $target: 'edit'
            },
            ufo_cs_cz_20: {
              $target: 'edit'
            },
            ufo_cs_cz_30: {
              $target: 'edit'
            },
            ufo_cs_cz_40: {
              $target: 'edit'
            },
            ufo_cs_cz_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'remark',
          name: '备注',
          originProp: 'remark',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'textArea',
              required: true,
            },
            ufo_cs_cz_60: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'voucherList',
          name: '回款凭证',
          originProp: 'fileList',
          originFrom: 'local',
          layout: {
            default: layoutParse.getData(1)
          },
          post(value) {
            return value ? (value as any[]).map(item => item.data) : null
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: true,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'disposeVoucherFile')
                }
              }
            },
            ufo_cs_cz_60: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'paymentCollectionDate',
          name: '回款日期',
          originProp: 'paymentCollectionDate',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'date',
              required: true,
              option: {
                time: {}
              }
            },
            ufo_cs_cz_60: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarName',
          name: '提车人姓名',
          originProp: 'takeCarName',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true
            },
            ufo_cs_cz_80: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarPhone',
          name: '提车人电话',
          originProp: 'takeCarPhone',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 20
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.mobilePhone.test(val) || RegExpRule.linePhone.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的联系方式'
                }
              ]
            },
            ufo_cs_cz_80: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarCard',
          name: '提车人身份证',
          originProp: 'takeCarCard',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 18
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.identityCard.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的身份证号'
                }
              ]
            },
            ufo_cs_cz_80: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'attachmentList',
          name: '附件',
          originProp: 'fileList',
          originFrom: 'local',
          layout: {
            default: layoutParse.getData(1)
          },
          post(value) {
            return value ? (value as any[]).map(item => item.data) : null
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: true,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'disposeAttachmentFile')
                }
              }
            },
            ufo_cs_cz_80: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'createdBy',
          name: '无',
          originProp: 'createdBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedBy',
          name: '无',
          originProp: 'updatedBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedTime',
          name: '无',
          originProp: 'updatedTime',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdName',
          name: '创建人',
          originProp: 'createdName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'createdTime',
          name: '创建时间',
          originProp: 'createdTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
      ]
    }
  },
  $getData(this: DisposeList) {
    return new Promise((resolve, reject) => {
      vehicleApi.vehicleDispose.require({
        ...this.$getSearch(),
        pageNo: this.$getPageData('current')!,
        pageSize: this.$getPageData('size')!
      }).then(res => {
        this.$formatList(res.data.data, res.data.totalCount)
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})

export default disposeList
